module.exports = __webpack_public_path__ + "static/img/26819(2).9786f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A1/26819(2).png
// module id = Otwa
// module chunks = 0